export default __webpack_public_path__ + "static/media/teachers_office.af2c80f1.png";